import SliderNextButton from './SliderNextButton';
export default SliderNextButton;
